import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Box = styled.div`
  padding: 20px;
  border-radius: 7px;
  background: linear-gradient(320deg, #e7e7e7 0%, #f6f7fa 100%);
  margin-top: 20px;
`;

export const ItemTitle = styled(Typography.Body)`
  margin-top: 20px;
  margin-bottom: 5px;
`;

export const PriceBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Progress = styled.div<{ $progress: number }>`
  background-color: ${({ theme }) => theme.palette.primary.background};
  width: 140px;
  height: 3px;
  border-radius: 7px;
  margin-top: 5px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${({ $progress }) => `${$progress}%`};
    background-color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const ProlongateButton = styled(Button)`
  margin-top: 20px;
`;
